import React from "react";
import FrameNavBar from "../../../features/NavBar/FrameNavBar";
import useAddIdsToUrl from "../../../utils/hooks/addIdsToUrl";
import useFacilityIds from "../../../utils/hooks/useFacilityIds";
import "./style.scss";
import RoutesComponent from "../Routes";
import useShowNavBar from "./useShowNavBar";
import Footer from "../../../features/Footer";

const FrameContainer: React.FC = () => {
  useFacilityIds();
  useAddIdsToUrl();
  const showNavBar = useShowNavBar();

  return (
    <React.Fragment>
      <div className={showNavBar ? "frame-content" : ""}>
        {/* {showNavBar && (
          <div className="iframe-nav" id="nawigacja-testowa">
            <FrameNavBar />
          </div>
        )} */}


    


        <div className={showNavBar ? "sale-content" : ""}>
          <RoutesComponent />
        </div>
        <Footer/>
      </div>
    </React.Fragment>
  );
};

export default FrameContainer;
